export const /** @type {?} */ ERROR_AUTHENTICATION_MESSAGES = {
  defaultMessage:
    'Mohon maaf, sistem kami tidak dapat memproses permintaan Anda saat ini',
  experiencingProblem:
    'Mohon maaf, sistem kami sedang mengalami kendala. Silahkan coba beberapa saat lagi',
  busyServer:
    'Mohon maaf, sistem kami sedang melayani banyak permintaan. Silahkan coba beberapa saat lagi',
  waitingForVerificationCode:
    'Jangan keluar dari halaman ini dan tunggu kode verifikasi max 1 Jam',
  connectionDisruption:
    'Sedang terjadi gangguan pada sistem sms kami, silakan coba beberapa saat lagi',
  noIdentifyPIN: 'Mohon maaf, nomor KTP Anda tidak ditemukan',
  requiredPIN: 'Nomor KTP wajib diisi',
  invalidPIN: 'Nomor KTP tidak valid',
  wrongOTPCode:
    'Maaf, kode OTP yang Anda masukkan tidak sesuai, silahkan cek kembali atau kirim ulang kode OTP.',
  requiredOTPCode: 'Nomor OTP tidak boleh kosong',
  phoneNumberNotRegistered:
    'Mohon maaf, nomor handphone yang Anda masukkan belum terdaftar. Silahkan mengajukan pinjaman terlebih dahulu',
  requiredPhoneNumber: 'Nomor handphone wajib diisi',
  numericalInputOnly: 'Masukkan angka saja',
  loginlimit:
    'Maaf limit OTP login anda telah habis, anda dapat melakukan login kembali besok',
};
